import React, { PureComponent } from 'react'
import { Routes, Route } from 'react-router-dom';
import './App.css';
import './admin.css';

import * as fs from 'file-saver';

import { EvaluationPerform } from './pages/Evaluation/EvaluationPerform.js'
import { EvaluationSave } from './pages/Evaluation/EvaluationSave.js'
import { EvaluationPrint } from './pages/Evaluation/EvaluationPrint.js'
import { BrowserDetails } from './pages/BrowserDetails'
import { Changelog } from './pages/Changelog'
import { Analysis } from './pages/Analysis/Analysis.js'
import { AnalysisDGSE } from './pages/Analysis/AnalysisDGSE.js'
import { AnalysisExport } from './pages/Analysis/AnalysisExport.js'
import { ResetSystem } from './pages/ResetSystem'
import Home from './pages/Home/Home.jsx';
import Navigation from './pages/Navigation/Navigation.jsx';
import NavbarTop from './pages/NavbarTop/NavbarTop';
import Toasts from './pages/Toasts/Toasts';
import ModalAreYouSure from './pages/Modals/ModalAreYouSure/ModalAreYouSure';
import ModalConsentGate from "./pages/Modals/ModalConsentGate/ModalConsentGate";
import ProtectedRoute from './pages/Navigation/ProtectedRoute';
import PageNotFound from './pages/PageNotFound/PageNotFound'
import ExamsWrapper from './pages/Exams/ExamsWrapper';
import EvaluationLoadWrapper from './pages/Evaluation/EvaluationLoadWrapper.js';
// import GlobalRedirect from './pages/Navigation/GlobalRedirect.js';

import { default_toast_showtime, strToolNameHeadline, apiEndpointGet, apiEndpointPost, criteria } from './pages/Consts';
// import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'bootstrap/dist/css/bootstrap.min.css';
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

import { Button, Modal, Container, Row, Col, Form } from 'react-bootstrap';

// import { ErrorBoundary } from './pages/ErrorBoundary'

// const strToolName = "DGSE Klassenarbeiten in den Fächern";
// const strToolName = "Unterrichtsentwicklung mit Ergebnissen von Klassenarbeiten";
// const strVersion = "1.0"; // Jun 18 23
const strMainHeadline = strToolNameHeadline;

// see https://dev.to/ashwin_mothilal/difference-between-pure-component-and-functional-component-51mi
// function App() {

const standardState = {
  type: "indi11_eval",
  statusExams: "changed",
  klassenarbeiten: [],
  statusNotice: "",
  criterion_a: "no",
  criterion_b: "no",
  criterion_c: "no",
  pos0_yes_no: 'no',
  analysis: {
    // pos0_yes_no: 'yes',
    pos0_finished: '',
    // pos0_criterion_a: "unchecked",
    // pos0_criterion_b: 'unchecked',
    // pos0_criterion_c: 'unchecked',
    pos0_tf_1: "",
    pos0_tf_1_sendBoard: 'unchecked',
    pos0_tf_board: "",

    pos1_yes_no: 'no',
    pos1_finished: '',
    pos1_criterion_a: 'unchecked',
    pos1_criterion_b: 'unchecked',
    pos1_criterion_c: 'unchecked',
    pos1_criterion_d: 'unchecked',
    pos1_tf_1: "",
    pos1_tf_1_sendBoard: 'unchecked',
    pos1_tf_2: "",
    pos1_tf_2_sendBoard: 'unchecked',
    pos1_tf_board: "",

    pos2_yes_no: 'no',
    pos2_finished: '',
    pos2_criterion_a: 'unchecked',
    pos2_criterion_b: 'unchecked',
    pos2_criterion_c: 'unchecked',
    pos2_criterion_d: 'unchecked',
    pos2_criterion_e: 'unchecked',
    pos2_criterion_f: 'unchecked',
    pos2_criterion_g: 'unchecked',
    pos2_criterion_h: 'unchecked',
    pos2_criterion_i: 'unchecked',
    pos2_criterion_j: 'unchecked',
    pos2_tf_1: "",
    pos2_tf_1_sendBoard: 'unchecked',
    pos2_tf_2: "",
    pos2_tf_2_sendBoard: 'unchecked',
    pos2_tf_board: "",

    pos3_yes_no: 'no',
    pos3_finished: 'unchecked',
    pos3_criterion_a: 'unchecked',
    pos3_criterion_b: 'unchecked',
    pos3_criterion_c: 'unchecked',
    pos3_criterion_d: 'unchecked',
    pos3_tf_1: "",
    pos3_tf_1_sendBoard: 'unchecked',
    pos3_tf_2: "",
    pos3_tf_2_sendBoard: 'unchecked',
    pos3_tf_board: "",

    pos4_yes_no: 'no',
    pos4_finished: 'unchecked',
    pos4_criterion_a: 'unchecked',
    pos4_criterion_b: 'unchecked',
    pos4_criterion_c: 'unchecked',
    pos4_criterion_d: 'unchecked',
    pos4_criterion_e: 'unchecked',
    pos4_tf_1: "",
    pos4_tf_1_sendBoard: 'unchecked',
    pos4_tf_2: "",
    pos4_tf_2_sendBoard: 'unchecked',
    pos4_tf_board: "",

    pos5_yes_no: 'no',
    pos5_finished: 'unchecked',
    pos5_criterion_a: 'unchecked',
    pos5_criterion_b: 'unchecked',
    pos5_criterion_c: 'unchecked',
    pos5_criterion_d: 'unchecked',
    pos5_criterion_e: 'unchecked',
    pos5_tf_1: "",
    pos5_tf_1_sendBoard: 'unchecked',
    pos5_tf_2: "",
    pos5_tf_2_sendBoard: 'unchecked',
    pos5_tf_board: "",

    pos6_yes_no: 'no',
    pos6_finished: 'unchecked',
    pos6_criterion_a: 'unchecked',
    pos6_criterion_b: 'unchecked',
    pos6_criterion_c: 'unchecked',
    pos6_criterion_d: 'unchecked',
    pos6_criterion_e: 'unchecked',
    pos6_tf_1: "",
    pos6_tf_1_sendBoard: 'unchecked',
    pos6_tf_2: "",
    pos6_tf_2_sendBoard: 'unchecked',
    pos6_tf_board: "",

    // anticipatory - how many?

    pos7_yes_no: 'no',
    pos7_finished: 'unchecked',
    pos7_criterion_a: 'unchecked',
    pos7_criterion_b: 'unchecked',
    pos7_criterion_c: 'unchecked',
    pos7_criterion_d: 'unchecked',
    pos7_criterion_e: 'unchecked',
    pos7_criterion_f: 'unchecked',
    pos7_criterion_g: 'unchecked',
    pos7_criterion_h: 'unchecked',
    pos7_criterion_i: 'unchecked',
    pos7_criterion_j: 'unchecked',
    pos7_tf_1: "",
    pos7_tf_1_sendBoard: 'unchecked',
    pos7_tf_2: "",
    pos7_tf_2_sendBoard: 'unchecked',
    pos7_tf_board: "",

    pos8_yes_no: 'no',
    pos8_finished: 'unchecked',
    pos8_criterion_a: 'unchecked',
    pos8_criterion_b: 'unchecked',
    pos8_criterion_c: 'unchecked',
    pos8_criterion_d: 'unchecked',
    pos8_criterion_e: 'unchecked',
    pos8_criterion_f: 'unchecked',
    pos8_criterion_g: 'unchecked',
    pos8_criterion_h: 'unchecked',
    pos8_criterion_i: 'unchecked',
    pos8_criterion_j: 'unchecked',
    pos8_tf_1: "",
    pos8_tf_1_sendBoard: 'unchecked',
    pos8_tf_2: "",
    pos8_tf_2_sendBoard: 'unchecked',
    pos8_tf_board: "",

    pos9_yes_no: 'no',
    pos9_finished: 'unchecked',
    pos9_criterion_a: 'unchecked',
    pos9_criterion_b: 'unchecked',
    pos9_criterion_c: 'unchecked',
    pos9_criterion_d: 'unchecked',
    pos9_criterion_e: 'unchecked',
    pos9_criterion_f: 'unchecked',
    pos9_criterion_g: 'unchecked',
    pos9_criterion_h: 'unchecked',
    pos9_criterion_i: 'unchecked',
    pos9_criterion_j: 'unchecked',
    pos9_tf_1: "",
    pos9_tf_1_sendBoard: 'unchecked',
    pos9_tf_2: "",
    pos9_tf_2_sendBoard: 'unchecked',
    pos9_tf_board: "",
  },

  analysissesc: {
    pos0_yes_no: 'no',
    pos0_tf_1: "",
    pos0_tf_1_sendBoard: 'unchecked',
    pos0_tf_2: "",
    pos0_tf_2_sendBoard: 'unchecked',
    pos0_tf_board: "",

    pos1_yes_no: 'no',
    pos1_tf_1: "",
    pos1_tf_1_sendBoard: 'unchecked',
    pos1_tf_2: "",
    pos1_tf_2_sendBoard: 'unchecked',
    pos1_tf_board: "",

    pos2_yes_no: 'no',
    pos2_tf_1: "",
    pos2_tf_1_sendBoard: 'unchecked',
    pos2_tf_2: "",
    pos2_tf_2_sendBoard: 'unchecked',
    pos2_tf_board: "",

    pos3_yes_no: 'no',
    pos3_tf_1: "",
    pos3_tf_1_sendBoard: 'unchecked',
    pos3_tf_2: "",
    pos3_tf_2_sendBoard: 'unchecked',
    pos3_tf_board: "",

    pos4_yes_no: 'no',
    pos4_tf_1: "",
    pos4_tf_1_sendBoard: 'unchecked',
    pos4_tf_2: "",
    pos4_tf_2_sendBoard: 'unchecked',
    pos4_tf_board: "",

    pos5_yes_no: 'no',
    pos5_tf_1: "",
    pos5_tf_1_sendBoard: 'unchecked',
    pos5_tf_2: "",
    pos5_tf_2_sendBoard: 'unchecked',
    pos5_tf_board: "",

    pos6_yes_no: 'no',
    pos6_tf_1: "",
    pos6_tf_1_sendBoard: 'unchecked',
    pos6_tf_2: "",
    pos6_tf_2_sendBoard: 'unchecked',
    pos6_tf_board: "",
  },
  helper: {
    modal: {
      header: "",
      body: "",
      footer_cancel: "Abbrechen",
      footer_confirm: "Bestätigen",
      method_confirm: null,
      visible: false,
      selected_exam: -1,
    },
    modalAYS: {
      header: "",
      body: "",
      footer_cancel: "Abbrechen",
      footer_confirm: "Bestätigen",
      method_confirm: null,
      visible: false,
    },
    api: {
      disch: '',
      school_year_name: new Date().getFullYear() + "/" + (new Date().getFullYear() + 1),
      reply_status_code: 0,
      reply_data: [],
      connected: false,
      last_connect: null,
      selected_option: null,
      school_class_id: null,
      lesson_id: null,
      send_eval: false,
      // transfered: []
    },
    offcanvas: {
      show: true,
    },
    collapse: {
      navdgse: false,
      navauswertungsstand: false,
    },
    toasts: [
      // severity: light, warning danger 
      // { id: 0, header: "Willkommen", body: "Hallo! Ich bin eine Info-Demo-Benachrichtigung und informiere Sie für sieben Sekunden.", showtime: 7000, timestamp: "jetzt", severity: "info", visible: true },
      // { id: 1, header: "Oha!", body: "Ich bin ein Warnung! Etwas muss wohl schief gelaufen sein... (nur drei Sekunden zu sehen!)", showtime: 3000, timestamp: "vorher", severity: "alert", visible: true },
      // { id: 2, header: "Toast Header 2", body: "Toast 2 Body", showtime: 4000, timestamp: "gleich", severity: "warning", visible: true },
      // { id: 3, header: "Toast Header 3", body: "Toast 3 Body", showtime: 6000, timestamp: "nie", severity: "alert", visible: true },
      // { id: 4, header: "Toast Header 4", body: "Toast 4 Body", showtime: 8000, timestamp: "spaeter", severity: "alert", visible: true },
    ],
    tooltips: true,
  },
}

class App extends PureComponent {

  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(standardState));
    this.standardState = JSON.parse(JSON.stringify(standardState));
    this.handleUnload = this.handleUnload.bind(this);
  }

  componentDidMount() {
    // document.cookie="API_ENDPOINT_URL=test.zsl-dgse.w11k.app"; // hardcore testing:)
    // document.cookie="API_ENDPOINT_URL=hurga.bum-baeh"; // hardcore testing:)

    window.addEventListener('beforeunload', this.handleUnload);
    window.addEventListener('unload', this.handleUnload); // not sure, if this one is needed
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleUnload);
    window.removeEventListener('unload', this.handleUnload);
  }

  handleCallbackToggleOffCanvas = () => {
    this.setState(prevState => ({
      helper: {
        ...this.state.helper,
        offcanvas: {
          show: !prevState.helper.offcanvas.show,
        }
      }
    }));
  }


  handleSendEvalSwitchChange = () => {
    this.setState(prevState => ({
      helper: {
        ...prevState.helper,
        api: {
          ...prevState.helper.api,
          send_eval: !prevState.helper.api.send_eval,
        },
      },
    }));
  };

  handleUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  }

  handleDGSENavUL = () => {
    const e = document.getElementById("dgseNavUL");
    e.style.display !== "block" ? e.style.display = "block" : e.style.display = "none";
  }

  handleLeftMenuBar = () => {
    const e = document.getElementById("pgside");
    // console.log(e.style.display.length);
    // console.log(e.style.display);
    // console.log(e.style.display === "undefined");
    (e.style.display !== "none" || e.style.display.length === 0) ? e.style.display = "none" : e.style.display = "block";
  }

  getDateTimeString = () => {
    return new Date().toLocaleString();
  }


  genFilename() {
    var invalid_chars = /[^a-zA-Z0-9_-]/g;
    // const fn = new Date().toISOString().slice(0, 10) + "-Analyse" + "-" +
    //   this.state.klassenarbeiten[0].schuljahr.replace(invalid_chars, "") + "-" +
    //   this.state.klassenarbeiten[0].fach.replace(invalid_chars, "") + ".json";
    const fn = `${new Date().toISOString().slice(0, 10)}-Analyse-${this.state.klassenarbeiten[0].schuljahr.replace(invalid_chars, "")}-${this.state.klassenarbeiten[0].fach.replace(invalid_chars, "")}.json`;
    return fn;
  }

  goModal = (which) => {
    let mData = [];
    let fix = 0;

    if (which === 'reset') {
      mData.push("Wollen Sie die Anwendung wirklich zurücksetzen?");
      mData.push("Bitte bestätigen Sie, dass Sie die Anwendung neu starten wollen. " +
        "Ihr aktueller Bearbeitungsstand geht dabei verloren. Diese Aktion kann nicht rückgängig gemacht werden.");
      mData.push("Nein!");
      mData.push("Ja, zurücksetzen!");
      mData.push(this.machineReset);
      mData.push(true);
      fix = 1;
    }
    else if (which === 'confirm_state_save_auto_filename') {
      const fn = this.genFilename();
      mData.push("Bearbeitungsstand speichern");
      mData.push('Ihr Browser unterbindet das Anzeigen eines "Speichern unter..." Dialogs. ' +
        'Der aktuelle Bearbeitungsstand wird unter dem Dateinamen "' + fn +
        '" in den "Download"-Ordner gespeichert. Möchten Sie fortfahren?');
      mData.push("Abbrechen");
      mData.push("Ja, speichern!");
      mData.push((e) => this.handleDirectSaveExecute(fn));
      mData.push(true);
      fix = 1;
    }

    if (fix !== 0) {
      this.setState(prevState => {
        let updatedItem = { ...prevState.helper.modalAYS };
        updatedItem.header = mData[0];
        updatedItem.body = mData[1];
        updatedItem.footer_cancel = mData[2];
        updatedItem.footer_confirm = mData[3];
        updatedItem.method_confirm = mData[4];
        updatedItem.visible = mData[5];
        return { helper: { ...prevState.helper, modalAYS: updatedItem } };
      })
    }
  }

  handleDirectSaveExecute = (fn) => {
    this.handleCancelModalAYS();
    try {
      const saveState = {
        ...this.state,
        helper: { ...standardState.helper }
      };
      const textFile = new Blob([JSON.stringify(saveState)], { type: 'application/json' });

      let dlFileName = fn;

      fs.saveAs(textFile, dlFileName);

      this.injectToast("Auswertungsstand gespeichert",
        "Der aktuelle Auswertungsstand wurde unter dem Dateinamen '" + dlFileName +
        "' auf Ihrem lokalen Dateisystem gespeichert.",
        default_toast_showtime,
        new Date().toLocaleString(),
        "info",
        true);
    } catch (error) {
      console.error("Error saving file:", error);
      this.injectToast("Speichern fehlgeschlagen",
        "Der aktuelle Auswertungsstand konnte nicht gespeichert werden.",
        default_toast_showtime,
        new Date().toLocaleString(),
        "alert",
        true);
    }
  };

  handleCallbackReset(ret) {
    this.setState(prevState => {
      let updatedItem = { ...prevState.helper.modalAYS };
      updatedItem.header = ret.header;
      updatedItem.body = ret.body;
      updatedItem.footer_cancel = ret.footer_cancel;
      updatedItem.footer_confirm = ret.footer_confirm;
      updatedItem.method_confirm = this.machineReset;
      updatedItem.visible = true;
      return { helper: { ...prevState.helper, modalAYS: updatedItem } };
    })
  }

  machineReset = () => {
    var wrapper = document.querySelector('.move-right');
    var toggleIconDiv = document.getElementById('toggle-icon-div');

    wrapper.classList.add('offcanvas-open');
    setTimeout(function () {
      toggleIconDiv.classList.remove('oc-close');
      toggleIconDiv.classList.add('oc-open');
    }, 50);

    this.setState(prevState => ({
      ...this.standardState,
      klassenarbeiten: [],
      helper: {
        ...this.standardState.helper,
        toasts: [
          {
            id: 0,
            header: "Werkzeug zurückgesetzt.",
            body: "Das Werkzeug wurde zurückgesetzt. Alle Daten wurden gelöscht.",
            showtime: default_toast_showtime,
            timestamp: new Date().toLocaleString(),
            severity: "danger",
            visible: true
          }
        ],
      }

      // statusNotice: "Auswertungsmaschine zurückgesetzt."
    }));
    this.forceUpdate();
    // this.handleCallbackSetNotice("Auswertungsmaschine zurückgesetzt.");
  }

  handleCallbackSetStatusExams = (v) => {
    this.setState(prevState => ({
      statusExams: v,
    }));
    this.forceUpdate();
    // console.log("should set status exams to: " + v);
  }

  handleCallbackSetCriteria = (a, b, c) => {
    // alert("hello from handleCallbackSetCriteria");
    // console.log("should set: " + a + " " + b + " " + c);
    // GVD!
    let value = "no";

    if (a === "yes" ||
      b === "yes" ||
      c === "yes") {
      value = "yes";
    }
    //   console.log("should set pos_0 auf yes");

    //   // const name = "pos0_yes_no";
    //   const value = "yes";
    //   this.setState({
    //     analysis: {
    //       ...this.state.analysis,
    //       pos0_yes_no: value,
    //     }
    //   })
    //   // this.forceUpdate();

    // }

    // this.setState(prevState => ({

    this.setState({
      criterion_a: a,
      criterion_b: b,
      criterion_c: c,
      pos0_yes_no: value,
    });
    this.forceUpdate();
    // }));
  }

  handleCallbackChangeFormEffClimate = (e) => {
    const name = e.target.name;
    const type = e.target.type;
    let value = e.target.value;

    if (type === "checkbox") {
      e.target.checked ? value = "checked" : value = "unchecked";
    }

    this.setState({
      analysissesc: {
        ...this.state.analysissesc,
        [name]: value,
      }
    })
  }

  handleCallbackChangeForm = (e) => {
    const name = e.target.name;
    const type = e.target.type;
    let value = e.target.value;

    if (type === "checkbox") {
      e.target.checked ? value = "checked" : value = "unchecked";
    }

    if (name === "pos0_finished" ||
      name === "pos1_finished" ||
      name === "pos2_finished"
    ) {
      e.target.checked ? value = Date.now() : value = "";
    }

    this.setState({
      analysis: {
        ...this.state.analysis,
        [name]: value,
      }
    })
  }

  handleCallbackLoadState = (s) => {
    // console.log("got load state: " + s);
    this.setState(prevState => s);
    this.forceUpdate();
    // const navigate = useNavigate();
  }

  handleCallbackUploadExam = (childData) => {
    // console.log("i am alerted from child component");
    // console.log("my data is:" + childData);

    let ka = this.state.klassenarbeiten;
    ka.push(childData);

    // console.log(ka);

    this.setState(prevState => ({
      statusExams: "changed",
      klassenarbeiten: ka,
    }));
    this.forceUpdate();
  }

  handleCallbackSetNotice = (text, header = "change me", severity = "info") => {
    this.injectToast(
      header,
      text,
      default_toast_showtime,
      new Date().toLocaleString(),
      severity,
      true);
  }

  injectToast = (header, body, showtime, timestamp, severity, visible) => {
    this.setState(prevState => {

      const updatedToasts = [...prevState.helper.toasts];
      const tLen = updatedToasts.length;

      const newToast = {
        id: tLen + 1,
        header: header,
        body: body,
        showtime: showtime,
        timestamp: timestamp,
        severity: severity,
        visible: visible,
      };
      updatedToasts.push(newToast);
      return { helper: { ...prevState.helper, toasts: updatedToasts } };
    });
  }
  // injectToast = (header, body, showtime, timestamp, severity, visible) => {
  //   this.setState(prevState => {
  //     const updatedToasts = prevState.helper.toasts;
  //     const tLen = updatedToasts.length;

  //     const newToast = {
  //       id: tLen + 1,
  //       header: header,
  //       body: body,
  //       showtime: showtime,
  //       timestamp: timestamp,
  //       severity: severity,
  //       visible: visible,
  //     };

  //     updatedToasts.push(newToast);
  //     return { helper: { ...prevState.helper, toasts: updatedToasts } };
  //   });
  // }

  handleCallbackRemoveExam = (ret, id, fileName) => {
    this.setState(prevState => {
      let updatedItem = { ...prevState.helper.modalAYS };
      updatedItem.header = ret.header;
      updatedItem.body = ret.body;
      updatedItem.footer_cancel = ret.footer_cancel;
      updatedItem.footer_confirm = ret.footer_confirm;
      updatedItem.method_confirm = () => this.removeExam(id, fileName);
      updatedItem.visible = true;
      return { helper: { ...prevState.helper, modalAYS: updatedItem } };
    })
  }

  removeExam = (id, fileName) => {
    let ka = this.state.klassenarbeiten;
    ka.splice(id, 1);
    this.setState(prevState => ({
      statusExams: "changed",
      // statusNotice: n,
      klassenarbeiten: ka,
      criterion_a: "no",
      criterion_b: "no",
      criterion_c: "no",
      helper: {
        ...prevState.helper,
        modalAYS: {
          ...prevState.helper.modalAYS,
          visible: false,
        }
      }
    }));
    this.injectToast(
      "Klassenarbeit entfernt",
      "Die Klassenarbeit " + fileName + " wurde entfernt.",
      default_toast_showtime,
      new Date().toLocaleString(),
      "warning",
      true);
    this.forceUpdate();
  }

  handleStatusNotice = () => {
    const s = this.state.statusNotice;
    return (s !== "" ? s &&
      <div className="mb-2 p-1 ps-2 pe-2 innerStatusInfoBox rounded-pill fw-bold">
        {s}
        <button className="btn float-end align-middle" onClick={() => this.dismissStatusNotice()}>&#x2718;</button>
        {/* <a className="pointerFinger link-underline-light innerStatusInfoBoxRemover" onClick={() => this.dismissStatusNotice()}>&#x2718;</a> */}

      </div> : ""
    );
  }

  handlePrint = () => {
    window.print();
  }

  dismissStatusNotice = () => {
    this.setState(prevState => ({
      statusNotice: ""
    }));
    this.forceUpdate();
  }

  handleCallbackCancelModalAreYouSure = () => {
    this.setState(prevState => {
      let updatedItem = { ...prevState.helper.modalAYS };
      updatedItem.visible = false;
      return { helper: { ...prevState.helper, modalAYS: updatedItem } };
    });
  }


  handleCancelModal = () => {
    this.setState(prevState => {
      let updatedItem = { ...prevState.helper.modal };
      updatedItem.visible = false;
      return { helper: { ...prevState.helper, modal: updatedItem } };
    });
  }

  handleCancelModalAYS = () => {
    this.setState(prevState => {
      let updatedItem = { ...prevState.helper.modalAYS };
      updatedItem.visible = false;
      return { helper: { ...prevState.helper, modalAYS: updatedItem } };
    });
  }

  handleCallbackSchoolYearChange = (n) => {
    this.setState(prevState => ({
      helper: {
        ...this.state.helper,
        api: {
          ...this.state.helper.api,
          school_year_name: n.target.value,
        }
      }
    }));
    this.forceUpdate();
  }

  handleCallbackDischChange = (d) => {
    if (/^\d*$/.test(d)) {
      this.setState(prevState => ({
        helper: {
          ...this.state.helper,
          api: {
            ...this.state.helper.api,
            disch: d,
          }
        }
      }));
      this.forceUpdate();
    }
  }

  handleCallbackConnectWebDB = () => {
    const school_year_name = this.state.helper.api.school_year_name;
    const disch = this.state.helper.api.disch;

    fetch(apiEndpointGet + "?school_year_name=" + school_year_name + '&disch=' + disch)
      .then(response => {
        return response.json().then(data => ({
          response,
          data
        }));
      })
      .then(({ response, data }) => {
        console.log(response, data);

        this.handleReplyDataGet(response, data);
      })
      .catch(error => {
        // console.error('Error fetching data: ', error);
        this.handleCallbackSetNotice("Fehler beim Abrufen der Schuldaten. " +
          "Um Ihre Analysen in die DGSE Datenbank einzuspielen ist eine Internetverbindung zwingend erforderlich.",
          "Fehler beim Abrufen der Schuldaten",
          "danger"
        );
      });
  };

  handleReplyDataGet = (response, data) => {

    if (response.status !== 200) {
      data = [];
    }

    this.setState({
      helper: {
        ...this.state.helper,
        api: {
          ...this.state.helper.api,
          reply_status_code: response.status,
          reply_data: data,
          connected: response.status === 200,
          last_connect: (response.status === 200) ? new Date().toLocaleString() : "",
        }
      }
    });

    if (response.status === 200 || response.ok) {
      // console.log("RECEIVED:");
      // console.log(data);
      this.handleCallbackSetNotice("Verbindung mit der DGSE Datenbank " +
        "(DGSE DiSch: " + this.state.helper.api.disch + " / Schuljahr: " +
        this.state.helper.api.school_year_name + ")"
        + " erfolgreich hergestellt.",
        "Verbindung erfolgreich",
        "info");
    }
    else {
      // console.error('Error fetching data: ', response.status);
      this.handleCallbackSetNotice("Fehler bei der Verbindung mit der Webdatenbank " +
        "(DGSE DiSch: " + this.state.helper.api.disch + " / Schuljahr: " +
        this.state.helper.api.school_year_name + "). " +
        "Bitte prüfen Sie die DGSE DiSch, das ausgewählte Schuljahr und ggf. Ihre Internetverbindung.",
        "Fehler beim Abrufen der Schuldaten",
        "danger");
    }
  }

  validateModalClassLectureInput(event) {

    let selected_option = null;
    let school_class_id = null;
    let lesson_id = null;

    var inputElement = document.getElementById('postDataList');
    var inputValue = inputElement.value.trim();
    var options = document.getElementById('datalistOptions').options;

    if (options === undefined) {
      alert('Keine Definitionen gefunden. Das sollte so nicht passieren :/');
      inputElement.value = inputValue.substring(0, inputValue.length - 1);
      return;
    }

    if (options.length === 0) {
      alert('Keine Klassen / Fächer vorhanden.');
      inputElement.value = "";
      return;
    }

    var isValid = Array.from(options).some(option =>
      option.value.toLowerCase().includes(inputValue.toLowerCase()));

    // console.log(inputValue); // Debugging
    // console.log(Array.from(options).map(option => option.value)); // Debugging
    // console.log(isValid); // Debugging

    if (!isValid) {
      // alert('Bitte wählen Sie einen gültigen Wert aus der Liste.');
      inputElement.value = inputValue.substring(0, inputValue.length - 1);
    } else {
      // console.log(inputValue);
      // console.log(this.state.helper.api.reply_data);

      const index = inputValue.indexOf(' ');

      if (index === -1) {
        // return [inputValue];
        // do nothing
      }
      else {
        const klasse = inputValue.substring(0, index).toLowerCase();
        const fach = inputValue.substring(index + 1).toLowerCase();

        // console.log(klasse, fach);
        for (let i = 0; i < this.state.helper.api.reply_data.length; i++) {
          const bg = this.state.helper.api.reply_data[i];
          for (let j = 0; j < bg.classes.length; j++) {
            const sClass = bg.classes[j];
            if (sClass.name.toLowerCase() === klasse) {
              for (let k = 0; k < sClass.lessons.length; k++) {
                const lesson = sClass.lessons[k];
                if (lesson.name.toLowerCase() === fach) {
                  // console.log(sClass.name, sClass.id);
                  // console.log(lesson.name, lesson.id);
                  selected_option = inputValue;
                  school_class_id = sClass.id;
                  lesson_id = lesson.id;
                }
              }
            }
          }
        }
      }


      // this.setState({
      //   helper: {
      //     ...this.state.helper,
      //     api: {
      //       ...this.state.helper.api,
      //       reply_status_code: response.status,
      //       reply_data: data,
      //       connected: response.status === 200,
      //       last_connect: new Date().toLocaleString(),
      //     }
      //   }
      // });

      this.setState({
        helper: {
          ...this.state.helper,
          api: {
            ...this.state.helper.api,
            selected_option: selected_option,
            school_class_id: school_class_id,
            lesson_id: lesson_id,
          }
        }
      });
      // console.log(this.state);
    }
  }

  handlePostData = () => {
    const postData = {
      "school_class_id": this.state.helper.api.school_class_id,
      "lesson_id": this.state.helper.api.lesson_id,
      "criteria_a": this.state.criterion_a === "yes" ? true : false,
      "criteria_b": this.state.criterion_b === "yes" ? true : false,
      "criteria_c": this.state.criterion_c === "yes" ? true : false,
      "send_to_ue": this.state.analysis.pos1_tf_2_sendBoard === "checked" ? true : false,
      "text_to_ue": this.state.analysis.pos1_tf_2_sendBoard === "checked" ? this.state.analysis.pos1_tf_2 : "",
      "export_ts": "" + Date.now() + "",
      // "payload": JSON.stringify(this.state.klassenarbeiten[this.state.helper.modal.selected_exam]),
      // "payload_filename": this.state.klassenarbeiten[this.state.helper.modal.selected_exam].fileName,
      "payload": this.state.helper.api.send_eval
        ? JSON.stringify(this.state.klassenarbeiten[this.state.helper.modal.selected_exam])
        : "",
      "payload_filename": this.state.helper.api.send_eval
        ? this.state.klassenarbeiten[this.state.helper.modal.selected_exam].fileName
        : ""
    };

    // console.log("postdata", postData);
    // console.log("send_eval", this.state.helper.api.send_eval);

    fetch(apiEndpointPost, {
      method: 'POST',
      body: JSON.stringify(postData),
      // body: postData,
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
      .then(response => {
        return response.json().then(data => ({
          response,
          data
        }));
      })
      .then(({ response, data }) => {
        this.handleReplyDataPost(response, data);
      })
      .catch(error => {
        console.error('Error posting data: ', error);
        this.handleCallbackSetNotice("Leider ist etwas schief gelaufen bei der Übermittlung der Daten. " +
          "Ihre Analyse wurde nicht in der Webdatenbank abgelegt. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es ggf. erneut.",
          "Fehler beim Übermitteln der Daten",
          "danger");
      });
  }

  handleReplyDataPost = (response, data) => {
    if (response.status !== 200 || !response.ok) {
      console.error('Error posting data: ', response.status);
      this.handleCallbackSetNotice("Die Übertragung Ihrer Analyse ist fehlgeschlagen. Die Webdatenbank hat einen Fehler gemeldet. " +
        "Setzen Sie sich bitte mit dem Support in Verbindung oder versuchen Sie es zu einem späteren Zeitpunkt erneut.",
        "Fehler beim Übermitteln der Daten",
        "danger");
    } else {
      // console.log("RECEIVED:");
      // console.log(response, data);
      // console.log("SHOULD SET " + this.state.helper.modal.selected_exam + " to transfered");
      this.handleCallbackSetNotice("Vielen Dank! Ihre Analyse wurde erfolgreich in die Webdatenbank übertragen übermittelt.",
        "Übertragung erfolgreich",
        "info"
      );

      const updatedKlassenarbeiten = this.state.klassenarbeiten.map((item, i) => {
        if (i === this.state.helper.modal.selected_exam) {
          return { ...item, saved_to_webdb: true };
        }
        return item;
      });
      this.setState({ klassenarbeiten: updatedKlassenarbeiten });
    };
    this.handleCancelModal();
  }

  handleCallbackTransferToWebDB = (idx) => {
    // console.log("should transfer: " + idx);

    const fix = 1;

    if (fix !== 0) {
      this.setState(prevState => {
        let updatedItem = { ...prevState.helper.modal };
        updatedItem.header = "Analyse & Dokumentation übertragen";
        // updatedItem.body = mData[1];
        updatedItem.footer_cancel = "Vorgang abbrechen";
        updatedItem.footer_confirm = "Analyse & Dokumentation übertragen";
        updatedItem.method_confirm = this.handlePostData;
        updatedItem.visible = true;
        updatedItem.selected_exam = idx;
        return { helper: { ...prevState.helper, modal: updatedItem } };
      })
    }
  }

  handleCallbackCollapse = (which) => {
    // if(which === "dgse") {
    this.setState(prevState => ({
      helper: {
        ...this.state.helper,
        collapse: {
          ...prevState.helper.collapse,
          [which]: !prevState.helper.collapse[which],
        }
      }
    }));
    // }
    // this.forceUpdate(); 
  }

  handleCallbackToggleToast = (id) => {
    this.setState(prevState => {
      const updatedToasts = prevState.helper.toasts.map(toast => {
        if (toast.id === id) {
          return { ...toast, visible: !toast.visible };
        }
        return toast;
      });
      return { helper: { ...prevState.helper, toasts: updatedToasts } };
    });
  }

  render() {
    const areExamsLoaded = this.state.klassenarbeiten.length > 0;
    const { send_eval } = this.state.helper.api;
    // console.log("send_eval: " + send_eval);
    return (
      <>
        <ModalConsentGate>

          <div className="move-right content-wrapper offcanvas-open">

            <NavbarTop
              parentState={this.state}
              backCallerHandleToggleOffCanvas={this.handleCallbackToggleOffCanvas}
              backCallerHandlePrint={this.handlePrint}
              // backCallerHandleReset={this.handleCallbackReset.bind(this)}
              backCallerGoModal={this.goModal}
            />

            <Container fluid>
              <main className="container-fluid mt-5">
                <h1>{strMainHeadline} <span id="printDateTime">Zeitpunkt: {this.getDateTimeString()}</span></h1>
                {/* <div className="statusInfoBox">{this.handleStatusNotice()}</div> */}
                {/* <GlobalRedirect condition={areExamsLoaded} /> */}
                <Routes>


                  <Route path="/auswertung/klassenarbeiten">
                    {/* <Route index element={<Exams parentState={this.state} */}
                    <Route index element={<ExamsWrapper parentState={this.state}
                      backCallerUploadExam={this.handleCallbackUploadExam}
                      // backCallerRemoveExam={this.handleCallbackRemoveExam}
                      backCallerHandleRemoveExam={this.handleCallbackRemoveExam}
                      backCallerSetNotice={this.handleCallbackSetNotice} />} />
                  </Route>

                  <Route
                    path="/auswertung"
                    element={<ProtectedRoute areExamsLoaded={areExamsLoaded}
                      loadedPath="/auswertung/klassenarbeiten"
                      unloadedPath="/auswertung/home" />}
                  />

                  <Route path="/auswertung/home" element={<Home />} />

                  <Route path="/auswertung/auswertung">
                    <Route index element={<EvaluationPerform parentState={this.state}
                      backCallerSetCriteria={this.handleCallbackSetCriteria}
                      backCallerSetStausExams={this.handleCallbackSetStatusExams} />} />
                    <Route path="laden" element={<EvaluationLoadWrapper
                      parentState={this.state}
                      backCallerLoadState={this.handleCallbackLoadState}
                      backCallerSetNotice={this.handleCallbackSetNotice} />} />
                    <Route path="speichern" element={<EvaluationSave
                      parentState={this.state}
                      standardState={this.standardState}
                      backCallerGoModal={this.goModal}
                      backCallerSetNotice={this.handleCallbackSetNotice} />} />
                    <Route path="drucken" element={<EvaluationPrint parentState={this.state} />} />
                  </Route>

                  {/* <Route path="/auswertung/analyseschritte">
                  <Route index element={<Analysis parentState={this.state}
                    backCallerChangeForm={this.handleCallbackChangeForm} />} />
                  <Route path="dgse"
                    element={<AnalysisDGSE
                      parentState={this.state}
                      backCallerChangeForm={this.handleCallbackChangeForm} />} />
                  <Route path="einspielen"
                    element={<AnalysisExport
                      parentState={this.state}
                      backCallerSetNotice={this.handleCallbackSetNotice}
                      backCallerConnectWebDB={this.handleCallbackConnectWebDB}
                      backCallerDischChange={this.handleCallbackDischChange}
                      backCallerSchoolYearChange={this.handleCallbackSchoolYearChange}
                      backCallerTransferToWebDB={this.handleCallbackTransferToWebDB}
                    />} />
                </Route> */}

                  <Route path="/auswertung/zuruecksetzen" element={<ResetSystem />} />
                  <Route path="/auswertungbrowser-details" element={<BrowserDetails />} />
                  <Route path="/auswertungchangelog" element={<Changelog />} />
                  <Route path="*" element={<PageNotFound />} />

                </Routes>
              </main>
            </Container>
          </div>

          <Navigation
            parentState={this.state}
            backCallerHandleToggleOffCanvas={this.handleCallbackToggleOffCanvas}
            backCallerHandleCollapse={this.handleCallbackCollapse}
            backCallerHandleReset={this.handleCallbackReset.bind(this)}
          />

          {/* <div> */}
          {/* Modal-Dialog */}
          <Modal className="modal-lg" show={this.state.helper.modal.visible}
            onHide={this.handleCancelModal}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
              <Modal.Title>{this.state.helper.modal.header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.state.helper.modal.body}

              {(this.state.helper.modal.selected_exam > -1) &&
                (this.state.klassenarbeiten[this.state.helper.modal.selected_exam] !== undefined) && (
                  <>

                    {/* <Row>
                    <Col as="h5" className="mt-2">
                      Ihre Schuldaten
                    </Col>
                  </Row>

                  <Row>
                    <Col>DiSch</Col><Col>{this.state.helper.api.disch}</Col>
                  </Row>
                  <Row>
                    <Col>Schuljahr</Col><Col>{this.state.helper.api.school_year_name}</Col>
                  </Row> */}

                    <Row className="mt-0">
                      <Col as="h4" className={this.state.helper.api.lesson_id === null ? 'text-danger' : 'text-success'}>
                        Klasse und Fach
                      </Col>
                      <Col>
                        {/* <input className="form-control" list="datalistOptions"
                          id="postDataList" placeholder="Bitte wählen Sie die Klasse und das Fach aus..."
                          onInput={(e) => this.validateModalClassLectureInput(e)}
                          value={this.state.helper.api.selected_option}
                        /> */}

                        <Form.Control
                          list="datalistOptions"
                          // size="lg"
                          id="postDataList"
                          type="text" placeholder="Bitte wählen Sie die Klasse und das Fach aus..."
                          onInput={(e) => this.validateModalClassLectureInput(e)}
                          // value={this.state.helper.api.selected_option}
                          value={this.state.helper.api.selected_option !== undefined ? this.state.helper.api.selected_option : ""}
                        />

                        {/* {console.log(this.state.helper.api.reply_data)} */}
                        <datalist id="datalistOptions">
                          {this.state.helper.api.reply_data.map(bg => (
                            bg.classes.map(sClass => (
                              sClass.lessons.map(lesson => (
                                <option key={sClass.id + "_" + lesson.id}
                                  id={sClass.id + "_" + lesson.id}
                                  value={sClass.name + " " + lesson.name}>
                                </option>
                              ))
                            ))
                          ))}
                        </datalist>
                      </Col>
                    </Row>

                    <Row>
                      <Col as="h5" className="mt-3">Folgende Daten werden übertragen</Col>
                    </Row>

                    <Row>
                      <Col as="h6">Klassenarbeit</Col>
                    </Row>
                    <Row>
                      <Col>Dateiname</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].fileName}</Col>
                    </Row>
                    <Row>
                      <Col>Jahr</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].schuljahr}</Col>
                    </Row>
                    <Row>
                      <Col>Fach</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].fach}</Col>
                    </Row>
                    <Row>
                      <Col>Klasse</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].klasse}</Col>
                    </Row>

                    <Row>
                      <Col as="h5" className="mt-3">DGSE Datenbank</Col>
                    </Row>

                    <Row>
                      <Col as="h6" className="mt-2">Aufmerksamkeitspunkte</Col>
                    </Row>
                    <Row>
                      <Col>{criteria[0]}</Col>
                      <Col>{this.state.criterion_a === "yes" ? "Ja" : "Nein"}</Col>
                    </Row>
                    <Row>
                      <Col>{criteria[1]}</Col>
                      <Col>{this.state.criterion_b === "yes" ? "Ja" : "Nein"}</Col>
                    </Row>
                    <Row>
                      <Col>{criteria[2]}</Col>
                      <Col>{this.state.criterion_c === "yes" ? "Ja" : "Nein"}</Col>
                    </Row>


                    <Row className="mt-2">
                      <Col as="h6">Hinweise, die an die Schulentwicklung gesendet werden</Col>
                      <Col>{this.state.analysis.pos1_tf_2_sendBoard === "checked" ? this.state.analysis.pos1_tf_2 : "Keine Hinweise."}</Col>
                    </Row>

                    <Row>
                      <Col as="h6" className="mt-2">
                        Optionale Übermittling Ihrer Auswertung
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        Es werden keinerlei personenbezogenen Daten versendet.
                      </Col>
                      <Col>
                        <Form>
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            label={send_eval ? (
                              <span className="text-success">Ihre Auswertung wird übermittelt.</span>
                            ) : (
                              "Ihre Auswertung wird nicht übermittelt."
                            )}
                            checked={send_eval}
                            onChange={this.handleSendEvalSwitchChange}
                          />
                        </Form>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col>Anzahl Schüler</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].grid.length}</Col>
                      </Row>
                      <Row>
                      <Col>Anzahl Aufgaben</Col><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].taskNames[0].length - 2}</Col>
                    </Row> */}
                    {/* <Row>
                      <Col>Maximalpunkte</div><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].realMaxPoints}</div>
                    </div> */}
                    {/* <Row>
                      <Col>Dateiname</div><Col>{this.state.klassenarbeiten[this.state.helper.modal.selected_exam].fileName}</div>
                    </div> */}

                  </>
                )}

            </Modal.Body>
            <Modal.Footer>
              {(this.state.helper.modal.footer_cancel.length > 0) && (
                <>
                  <Button variant="secondary" onClick={this.handleCancelModal}>
                    {this.state.helper.modal.footer_cancel}
                  </Button>
                </>
              )}

              {(this.state.helper.api.school_class_id !== null) && (
                <>
                  <Button variant="primary" onClick={this.state.helper.modal.method_confirm}>
                    {this.state.helper.modal.footer_confirm}
                  </Button>
                </>
              )}

              {(this.state.helper.api.school_class_id === null) && (
                <>
                  <div className="not_allowed">
                    <Button disabled variant="primary">
                      {this.state.helper.modal.footer_confirm}
                    </Button>
                  </div>
                </>
              )}

            </Modal.Footer>
          </Modal>
          {/* </div> */}

          <ModalAreYouSure
            parentState={this.state}
            backCallerHandleCancelModalAreYouSure={this.handleCallbackCancelModalAreYouSure}
          />

          <Toasts
            parentState={this.state}
            backCallerHandleToggleToast={this.handleCallbackToggleToast}
          />
        </ModalConsentGate>
      </>
    );
  }
}

// var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//   return new bootstrap.Tooltip(tooltipTriggerEl)
// })

window.addEventListener("unhandledrejection", (event) => {
  console.warn('PROMISE REJECTION: ' + event.reason);
  event.preventDefault();
});

// var offcanvasNavbarElement = document.getElementById('offcanvasNavbar');
// var wrapper = document.querySelector('.move-right');
// var toggleIconDiv = document.getElementById('toggle-icon-div');

// offcanvasNavbarElement.addEventListener('show.bs.offcanvas', function () {
//   wrapper.classList.add('offcanvas-open');

//   setTimeout(function () {
//     toggleIconDiv.classList.remove('oc-close');
//     toggleIconDiv.classList.add('oc-open');
//   }, 50);
// });

// offcanvasNavbarElement.addEventListener('hidden.bs.offcanvas', function () {
//   wrapper.classList.remove('offcanvas-open');

//   setTimeout(function () {
//     toggleIconDiv.classList.remove('oc-open');
//     toggleIconDiv.classList.add('oc-close');
//   }, 50);
// });

export default App;
